import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleRegisterSynchronizationStatus from "./vehicleRegisterSynchronizationStatus";
import VehicleRegisterVehicleIdentificationResponse from "./vehicleRegisterVehicleIdentificationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleRegistrationChangeExemptionResponse {
  @observable
  exemptionId: string;
  /**
   * Vehicle registration plate.
   */
  @observable
  licensePlate!: string;

  /**
   * Country ID.
   */
  @observable
  countryId!: string;

  @observable
  vehicleRegisterSynchronizationStatus!: VehicleRegisterSynchronizationStatus;

  @observable
  @Type(() => VehicleRegisterVehicleIdentificationResponse)
  vehicleRegisterVehicle?: VehicleRegisterVehicleIdentificationResponse;

  /**
   * Exemption is valid since this date.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * Exemption valid until this date. If null, exemption should not expire.
   */
  @observable
  @Type(() => Date)
  validUntil?: Date;

  /**
   * Record ID for exemption created state.
   */
  @observable
  creationRecordId!: string;

  /**
   * Record ID for exemption validity ending state.
   */
  @observable
  cancellationRecordId?: string;

  /**
   * Exception reason id.
   */
  @observable
  exemptionReasonId!: string;
}
